export const API_URL = `https://forkify-api.jonas.io/api/v2/recipes/`;
export const TIMEOUT_TIMER = 10;
export const RES_PER_PAGE = 10;
